// @flow
import type { Element, Node } from 'react';

import React from 'react';
import { Label as BaseLabel } from 'reactstrap';
import Tip from '#components/support/tooltips/Tip/index.jsx';

type Props = {
  field: {
    label: string | Function,
    name: string,
    tipId?: string,
  },
  component?: typeof BaseLabel | 'span',
  children?: Node,
  excludeTip?: boolean,
  tipTargetId?: string | null,
  state: {
    values: Object,
    visibleFields: Object,
    autofilled: Object,
  },
};

const EnhancedLabel = ({
  field,
  component = BaseLabel,
  excludeTip = false,
  tipTargetId = null,
  state,
  children = null,
}: Props): Element<typeof BaseLabel> | Element<'span'> => {
  const labelText =
    typeof field.label === 'function' && state && state.values ? field.label(state) : field.label;

  const resolvedTipId =
    typeof field.tipId === 'function' && state && state.values ? field.tipId(state) : field.tipId;

  const tip =
    excludeTip || !resolvedTipId ? null : (
      <>
        {' '}
        <Tip tipId={resolvedTipId} targetId={tipTargetId} />
      </>
    );

  let props = {};
  if (component === BaseLabel) {
    props = { htmlFor: field.name };
  }
  return React.createElement(component || BaseLabel, props, children || labelText, tip);
};

export default EnhancedLabel;
